export default __webpack_public_path__ + "static/media/Sage's Leggings of the Aureate.b93b17d4.jpg";